export default __webpack_public_path__ + "static/media/DigitalAIr_logo.cd683c17.png";